// tslint:disable
/**
 * Ux
 * insightux admin api
 *
 * The version of the OpenAPI document: 0.62
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { TaTransparencyBreakdownEntryFromJSON, TaTransparencyBreakdownEntryToJSON, } from './';
export function TaTransparencyMetricFromJSON(json) {
    return {
        'meanFit': !exists(json, 'meanFit') ? undefined : json['meanFit'],
        'breakdown': !exists(json, 'breakdown') ? undefined : json['breakdown'].map(TaTransparencyBreakdownEntryFromJSON),
    };
}
export function TaTransparencyMetricToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'meanFit': value.meanFit,
        'breakdown': value.breakdown === undefined ? undefined : value.breakdown.map(TaTransparencyBreakdownEntryToJSON),
    };
}
